"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-twelve/sections/workSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WorkSection366sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" | "4s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/icons/work-icon-1.svg" | "/Templates/Doccure/img/icons/work-icon-2.svg" | "/Templates/Doccure/img/icons/work-icon-3.svg" | "/Templates/Doccure/img/icons/work-icon-4.svg" */
    src: string;
    /** Detected variants: "Book Your Test" | "Sample Collection" | "Laboratory Analysis" | "Receive Results" */
    h30Text: ReactNode;
    /** Detected variants: "Step 1" | "Step 2" | "Step 3" | "Step 4" */
    p0Text: ReactNode;
    /** Detected variants: "Schedule your test online and choose from a wide range of reliable diagnostic services." | "Our phlebotomists collect your samples comfortably, following quality protocols.." | "Your samples are analyzed advanced systems & by certified experts for accuracy." | "Receive your reports via email, SMS, or our expert guidance available whenever you need" */
    p1Text: ReactNode;
    /** Detected variants: "col-xl-3 col-lg-6 col-md-6" */
    className?: string;
    /** Detected variants: "works-item-twelve wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "booking-icon" */
    div0ClassName2?: string;
    /** Detected variants: "service" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "services-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "badge-icon" */
    p0ClassName?: string;
    /** Detected variants: "description" */
    p1ClassName?: string;
};
export type HomeTwelveWorkSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection366sItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "How" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Works" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Booking Process" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Discover our most trusted & essential test packages to meet every individual’s needs." */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "service" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/works-img.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    workSection366s: WorkSection366sItem[];
    workSection366sItemWrapper?: (item: WorkSection366sItem, content: ReactNode) => ReactNode;
    workSection366sRenderer?: (defaultNode: ReactNode) => ReactNode;
    workSection366sImageVisible?: boolean;
    workSection366sImageRenderer?: (item: WorkSection366sItem, defaultNode: ReactNode) => ReactNode;
    workSection366sH3Visible?: boolean;
    workSection366sH3Renderer?: (item: WorkSection366sItem, defaultNode: ReactNode) => ReactNode;
    workSection366sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WorkSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    workSection366sH3Props?: Partial<ComponentProps<"h3">> | ((item: WorkSection366sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwelveWorkSectionGenerated: FC<HomeTwelveWorkSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "How",
    sectionDiv0Div0H20H2Text2 = "Works",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Booking Process",
    sectionDiv0Div0P0PText = "Discover our most trusted & essential test packages to meet every individual’s needs.",
    sectionImageWithBasePath0ImageAlt = "service",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/works-img.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    sectionDiv0Div1ClassName,
    workSection366s,
    workSection366sItemWrapper,
    workSection366sRenderer,
    workSection366sImageVisible,
    workSection366sImageRenderer,
    workSection366sH3Visible,
    workSection366sH3Renderer,
    workSection366sImageProps,
    workSection366sH3Props,
}) => {
    return (
        <section className="works-section-twelve section">
            <div className="container">
                <div className="section-header section-header-twelve text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            <span className="text-primary">{sectionDiv0Div0H20Span0SpanText}</span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                    <p className="description">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row"}>
                    {renderCollectionNode(
                        workSection366s,
                        (item: WorkSection366sItem) => (
                            <div className={item.className ?? "col-xl-3 col-lg-6 col-md-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "works-item-twelve wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "booking-icon"}>
                                        {renderItemNode(workSection366sImageVisible, workSection366sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "service"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof workSection366sImageProps === "function" ? workSection366sImageProps(item) : (workSection366sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "services-content"}>
                                        <p className={item.p0ClassName ?? "badge-icon"}>{item.p0Text}</p>
                                        {renderItemNode(workSection366sH3Visible, workSection366sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof workSection366sH3Props === "function" ? workSection366sH3Props(item) : (workSection366sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p1ClassName ?? "description"}>{item.p1Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        workSection366sItemWrapper,
                        workSection366sRenderer
                    )}
                </div>
            </div>
            <div className="icon-2"></div>
            <div className="icon-3"></div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid works-img" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTwelveWorkSectionGenerated;
